export default {
  companySurveysMetadata: {
    surveys: {
      title: 'Surveys',
      periodic: 'Periodic survey',
      nonperiodic: 'Non-periodic survey',
      report: 'Summary',
      details: 'By individual users',
      emplStatistic: 'Employees passed the survey',
      allQuestions: 'All',
      createButton: 'Create a new survey',
      surveyDone: 'Survey is done',
      surveyPlaceholder: 'There are no scheduled or pending surveys yet',
      table: {
        headers: {
          name: 'Name',
          lastSend: 'Last send',
          nextSend: 'Next send',
          dateStart: 'Start date',
          dateEnd: 'End date',
          period: 'Period',
          count: 'Statistic',
          status: 'Status',
        },
      },
      statuses: {
        draft: 'Draft',
        published: 'Published',
      },
      changeButton: 'Edit a survey',
      menu: {
        sendToParticipants: 'Assign the participants',
        sendNow: 'Send now',
        reSendNow: 'Send a reminder',
        makeUnavailable: 'Make unavailable',
        makeAvailable: 'Make available',
        exportResults: 'Export results',
        copyLink: 'Copy the link',
        copyEntity: 'Copy the survey',
        copyEntityTo: 'Copy into other company',
        del: 'Delete survey',
      },
      successMessages: {
        changeStatus: 'Survey availability changed successfully',
        copyEntity: 'Survey successfully copied',
        sendNow: 'Survey successfully sent',
      },
      errorMessages: {
        changeStatus: 'Failed to change survey availability',
        copyEntity: 'Failed to copy survey',
        sendNow: 'Failed to send survey',
        copyEntityNotSelected: 'No one company selected',
      },
    },
    tests: {
      title: 'Tests',
      unregistered: 'Unregistered user',
      validAnswers: 'Result',
      periodic: 'Periodic test',
      nonperiodic: 'Non-periodic test',
      createButton: 'Create a new test',
      testDone: 'Test is done',
      testPlaceholder: 'No tests scheduled yet',
      table: {
        headers: {
          name: 'Name',
          lastSend: 'Last send',
          nextSend: 'Next send',
          dateStart: 'Start date',
          dateEnd: 'End date',
          period: 'Period',
          count: 'Count results',
          availability: 'Allowed for guests',
          status: 'Status',
        },
      },
      statuses: {
        draft: 'Draft',
        published: 'Published',
      },
      changeButton: 'Edit a test',
      menu: {
        sendToParticipants: 'Assign the participants',
        reSendNow: 'Send a reminder',
        sendNow: 'Send now',
        makeUnavailable: 'Make unavailable',
        makeAvailable: 'Make available',
        exportResults: 'Export results',
        copyLink: 'Copy the link',
        copyEntity: 'Copy the test',
        copyEntityTo: 'Copy into other company',
        del: 'Delete the test',
      },
      successMessages: {
        changeStatus: 'Test availability changed successfully',
        copyEntity: 'Test successfully copied',
        sendNow: 'Test successfully sent',
      },
      errorMessages: {
        changeStatus: 'Failed to change test availability',
        copyEntity: 'Failed to copy test',
        sendNow: 'Failed to send test',
        copyEntityNotSelected: 'No one company selected',
      },
    },
    availability: {
      availabilityTooltip:
        'Unauthorized users are allowed to pass. The results of the passage will be depersonalized.',
      availabilityGuestTooltip:
        'The results of the survey/test will not display information about the user.',
      availabilityNotGuestTooltip:
        'The results of the survey/test display information about all users, if the user is not logged in, then his answers will be marked as guest answers.',
    },
    cycle: 'Cycle',
    totalAnswers: 'Total answers',
    lastAnswer: 'Last answer',
    questions: {
      phone: 'Phone',
      notFound: 'Question type not recognized',
      boolean: 'Yes or no',
      number: 'Number',
      text: 'Short text',
      date: 'Date',
      textarea: 'Long text',
      file: 'File',
      scale: 'Scale',
      time: 'Time',
      default: '- Choose question type -',
      multi_choice: 'Multi - selection',
      single_choice: 'Single choice',
    },
    questionFields: {
      validAnswer: 'Right answer',
      showValidAnswer: 'Specify the correct answer',
      units: 'Units of measurement',
      minMax: 'Min/max value',
      unitsPlaceholder: 'For example: pcs, kg, days',
      from: 'From',
      to: 'To',
      decimals: 'Allow decimals',
      answerVariants: 'Answer option',
      scaleMaxLength: 'Maximum length of titles: 30 characters',
      scaleMaxLengthHint:
        'The scale will be displayed horizontally only with numbers, if texts are indicated in the scale values - then the scale will be displayed vertically',
      answerVariantsPlaceholder: 'Enter the name of the answer option',
      addVariant: 'Add another option',
      delVariant: 'Delete an option',
      pointCount: 'Number of points',
      startsWith: 'Starts with «1» value',
      scaleBegin: 'Scale begin',
      scaleBeginPh: 'Enter the name of the first point',
      scaleEnd: 'Scale end',
      scaleEndPh: 'Enter the name of the last point',
      maxLength: 'Length limitation',
      addFile: 'Attach a file',
      addedFile: 'Attached file',
      surveyTextQuestionLabel: 'Answer',
      showInFeed: 'Enable the display of a question in the feed',
      showInFeedHint:
        'The answer will be published in the <strong> feed without specifying your name</strong>',
      question: 'Question',
      questionPlaceholder: 'Enter the question text',
      qType: 'Question type',
      showRich: 'Include an extended description of the question',
      richBody: 'Extended description',
      surveySettingsAdditional: 'Evaluation of the result is not included',
      surveySettingsAdditionalBtn: 'Turn on',
      surveySettingsAdditionalLink: 'Go to setting up the evaluation of results',
      newOption: 'New version',
      copyQuestion: 'Copy a question',
      copyPrefix: 'Copy',
      editQuestion: 'Edit the question',
      deleteForever: 'Delete without the possibility of recovery',
      moveDown: 'Move below',
      moveUp: 'Move higher',
      restore: 'Restore',
      finishButtonName: 'Complete the passage',
      addQuestion: 'Add a question',
      deleted: 'The question {num} has been deleted.',
    },
    successMessages: {
      deleteResearchment: 'Researchment successfully deleted',
      deleteTemplate: 'The template successfully deleted',
      deleteSurvey: 'Survey deleted',
      sendSurvey: 'The survey sent successfully',
      changeTimetable: 'The survey changed successfully',
      sendSurveyTest: 'The test sent successfully',
      changeTimetableTest: 'The test changed successfully',
      copyTemplate: 'Template copied successfully',
      copyResearchment: 'Researchment copied successfully',
      createResearchment: 'Researchment created successfully',
      createTemplate: 'Template created successfully',
      assignResearchment: 'The researchment was successfully assigned',
      saveResearchment: 'Researchment saved',
    },
    errorMessages: {
      deleteResearchment: 'Failed to delete researchment',
      deleteTemplate: 'Failed to delete the template',
      sendSurvey: 'Failed to send the survey',
      getTimetable: 'There are no teams in subordination',
      changeTimetable: 'Failed to change the survey',
      sendTest: 'Failed to send the test',
      changeTimetableTest: 'Failed to change the test',
      copyTemplate: 'Error coping template',
      copyResearchment: 'Error coping researchment',
      createTemplate: 'Error creating template',
      assignResearchment: 'Researchment assignment failed',
      saveResearchment: 'Error when saving researchment',
    },
    confirm: {
      deleteResearchment: 'Delete the researchment?',
      ungroup: 'Attached surveys or tests will be ungrouped and saved',

      continueResearchment: 'Continue researchment?',
      restart:
        'Do you want to restart the researchment again, or continue the current cycle?<br/><br/>In the case of a manual restart, existing surveys will end and new ones will be created.<br/>Also in this case, you will also have to manually enter the start dates for new surveys and click the start button again.',
      submitRestart: 'Yes, restart',
      continueCurrent: 'Continue the current one',
      deleteTemplate: 'Delete the template?',

      deleteSurvey: 'Delete survey?',
      submitDelete: 'Yes, delete',
      questionDeleteSurvey:
        'Are you sure you want to delete the survey? All existing results will be deleted along with the survey. The action cannot be discarded.',

      confirmDeleteRecipients: 'Delete the employees?',
      excludeSurvey: 'Employees will be excluded from the survey recipients',
      excludeTest: 'Employees will be excluded from the test recipients',
    },
    confirmDeleteAllRecipients: {
      title: 'Delete all employees?',
      textSurvey: 'All employees of the company will be excluded from the survey recipients',
      textTest: 'All employees of the company will be excluded from the test recipients',
    },
    confirmAddAllRecipients: {
      title: 'Add all employees?',
      textSurvey: 'All employees of the company will be added to the recipients of the survey',
      textTest: 'All employees of the company will be added to the recipients of the test',
    },
    tableHeaders: {
      title: 'Title',
      description: 'Description',
    },
    commonHint: 'Is common template',
    buttons: {
      deleteTemplate: 'Delete the template',
      deleteResearchment:
        'Deleting a researchment, attached surveys or tests will be ungrouped and saved',
      //было изначально так, что started - это stop, менять не стал
      started: 'Stop',
      stopped: 'Run',
      paused: 'Continue',
    },
    manageTemplates: 'Manage researchment templates',
    noTemplates:
      "You don't have any templates yet. To create a template, create a researchment and save it as a template",
    noSurvey:
      "You don't have any surveys yet. To create a survey, click on the «Create a new survey» button",
    noTest:
      "You don't have any tests yet. To create a test, click on the «Create a new test» button",
    noResearchment:
      "You don't have any researchment yet. To create a researchment, click on the «Create researchment» button",
    noCompanyEmployees:
      'To assign the survey, add employees to the company. To do this, go to the tab',
    noEmployees: 'All employees are already participating in the survey',
    noEmployeesTest: 'All employees are already participating in the testing',
    noRecipients:
      'Not a single user has taken part in the survey yet. You can invite participants on the «Assign» tab',
    noRecipientsTest:
      'Not a single user has taken part in the test yet. You can invite participants on the «Assign» tab',
    noAnswers: 'There are no answers in the selected survey or cycle yet',
    guest: 'Guest',
    anonymous: 'Anonymous',
    member: 'Member',
    date: 'Passing date',
    saveAsTemplate: 'Save as template',
    selectSurveys: 'Select surveys/test to include in the researchment',
    delFromResearchment: 'Delete from researchment',
    changeDates: 'Change dates',
    dateNotDefined: 'Not defined',
    enterResearchment: 'Enter a name of the researchment',
    enterMethodology: 'Enter a description of the methodology',
    repeat: 'Repeat',
    accessBlock: 'Choose who will have access to the surveys',
    datesBlock: 'Select research dates',
    researchments: 'Researchments',
    researchment: 'Researchment',
    statuses: {
      started: 'Started',
      stopped: 'Stopped',
      paused: 'Paused',
    },
    tabs: {
      content: 'Content of researchment',
      settings: 'Settings',
      assign: 'Assign',
      recipients: 'Assignee',
    },
    researchmentSettings: 'Researchment settings',
    warning: 'Warning',
    anonSettings:
      'Survey settings will be changed according to the researchment settings, except for the anonymity setting',
    setting: 'Tune-up',
    contentResearchment: 'Content of researchment',
    copy: 'Copy the researchment',
    delete: 'Delete the researchment',
    hints: {
      description: 'Not displayed when completing surveys',
      date: 'The survey can be completed during this date',
      period: 'Number of days',
      settings: 'The researchment settings will be applied to all attached surveys',
      dates: 'Surveys within the researchment will be limited to these dates.',
      copyTemplate: 'Copy as template',
      commonTemplate: 'Common template for all companies',
      selectCompany: 'Select company',
      enterResearchment: 'Enter the name of the researchment',
      selectTemplate: 'Select a template',
      enterTemplate: 'Enter the name of the template',

      message: 'It will be inserted into the letter template as an accompanying information',
      preview:
        'It will be displayed in messenger messages if you share a link, or the survey will be sent via a telegram bot',
      directLink:
        'Updated after saving changes. If such a name already exists, it will be supplemented with the survey/test number',
      showHeader: 'Will be displayed in the survey/test header',
      finishMessage: 'It will be shown to the user after the survey is completed',
      showFinishPercent:
        'If you check the box, the user will be able to see the percentage in the personal account',
      surveySettingsCount: 'Only questions with the correct answer are included in the scoring',
    },
    createResearchment: 'Create researchment',
    total: 'Total',
    info: 'Information',
    action: 'Action',
    inCurrentCycle: 'Into current cycle №',
    managingTemplates: 'Template management',

    assignSurvey: 'Assign the survey',
    assignTest: 'Assign the test',
    sendSurveyDescription:
      'Users will receive{first}email at 10:00 on the date specified as the start of the survey. If the survey starts today or earlier, the selected users will receive emails immediately after you click on the «Done» button',
    sendTestDescription:
      'Users will receive{first}email at 10:00 on the date specified as the start of the test. If the test starts today or earlier, the selected users will receive emails immediately after you click on the «Done» button',
    allCompany: 'For the whole company',
    fromAllCompany: 'Delete all',
    first: ' the first ',

    enterName: 'Enter the name',
    createTemplate: 'Create a template',
    assignResearchment: 'Assign of researchment',
    appoint: 'All employees of the selected departments will be assigned to the researchment',
    copyInCompany: 'Copy into other company',
    selectCompanies: 'Select company or companies for copy {subj} into them',
    searchByName: 'Search by company name',
    passPeriod: 'Survey period',
    sendSurvey: 'Send the survey?',
    sendTest: 'Send the test?',
    onlyFor:
      'Emails and notifications will only be sent to users who have not previously received this survey',
    descriptionResearchment: 'Researchment description',
    surveyEdit: {
      titleSurveyCreate: 'Create survey',
      titleTestCreate: 'Create test',
      titleSurvey: 'Edit survey',
      titleTest: 'Edit test',
      main: 'Settings',
      questions: 'Questions',
      mailing: 'Edit e-mails',
      access: 'Access',
      scoring: 'Scoring settings',
      accessBlockTitle: 'Choose who will have access to the survey',
      successInfo: 'Access settings saved',
      subject: 'Subject',
      message: 'Text',
      messageHint: 'It will be inserted into the letter template as an accompanying information',
      messageInfo: 'Mailing settings saved',
      previewHint:
        'It will be displayed in messenger messages if you share a link, or the survey will be sent via a telegram bot',
      directLinkHint:
        'Updated after saving changes. If such a name already exists, it will be supplemented with the survey/test number',
      link: 'Survey link',
      finishMessage: 'Message at the end of the survey fill',
      descriptionHint: 'Will be displayed in the survey/test header',
      finishMessageHint: 'It will be shown to the user after the survey is completed',
      successCreate: '{entity} created',
      successSettingsInfo: 'Settings saved',
      preview: 'Preview for messenger',
      showFinishPercentHint:
        'If you check the box, the user will be able to see the percentage in the personal account',
      showFinishPercent: 'Show the number of points scored',
      surveyResultSettings: 'Configuring results',
      surveySettingsTooltip: 'Rating and counting system settings',
      newTitleTpl: 'New {entity} in {company}',
      successAddInfo: 'Question added',
      successDelInfo: 'The question is deleted',
      successCopyInfo: 'The question is copied',
      successUpdateInfo: 'The changes is saved',
      successEnableScoringInfo: 'Results evaluation mode enabled',
      successEvaluationInfo: 'Scoring settings saved',
      surveySettingsCount: 'Total questions with answers',
      surveySettingsCountHint: 'Only questions with the correct answer are included in the scoring',
      surveySettingsSum: 'Total points:',
      surveySettingsLabel: 'Evaluation of the result set-off/non-set-off',
      surveySettingsEnableTooltip:
        "To disable the evaluation of the result according to the offset/non-offset system, remove the checkbox and click on the 'Save' button",
      surveySettingsTimeLabel: 'Limit test time',
      surveySettingsTimeTooltip:
        "To disable the limit of the test time, remove the checkbox and click on the 'Save' button",
      surveySettingsTimeFiledLabel: 'How much time is allocated for completion',
      surveySettingsSuccessMinimumLabel: 'Pass minimum',
      surveySettingsSuccessLabel: 'Pass',
      surveySettingsFailureLabel: 'Fail',
      surveySettingsDisabled:
        'To set up an evaluation, you need at least one question with given points for the correct answer',
      surveyMinMaxScoreError:
        'The pass minimum cannot be more than the maximum number of points in the test',
      shareReportTitle: 'Share analytics',
      answers: 'Answers on questions',
    },
    sendNow: {
      onlyFor:
        'Emails and notifications will only be sent to users who have not previously received this survey or test',
      resend:
        'Emails and notifications will be sent to all users who are assigned but have not completed this survey or test',
    },
  },
};
